

export class SolicitudVo{
  strNiv!: string;
  strPlaca!: string;
  strMotivoSolicitud!: string;
  strCertificadoPor!: string;
  strTipoServicio!: string;
  strCategoria!: string;
  strMarca!: string;
  strSubmarca!: string;
  strModelo!: string;
  strMotor!: string;
  strRefrendo!: string;
  strRepuve!: string;
  strRfc!: string;
  strCurp!: string;
  strNombre!: string;
  strApellidoPaterno!: string;
  strApellidoMaterno!: string;
  strSexo!: string;
  strFechaNacimiento!: string; // formato ISO: yyyy-mm-dd
  strCalle!: string;
  strNumeroExterior!: string;
  strNumeroInterior!: string;
  strCodigoPostal!: string;
  strEstado!: string;
  strMunicipio!: string;
  strLocalidad!: string;
  strNumeroTelefono!: string; // 10 dígitos
  strCorreoElectronico!: string;
  strSolicitudDoc!: string;
  strFacturaDoc!: string;
  strIneDoc!: string;
  strRepuveDoc!: string;

}
